import { FIELD_TYPE } from "@saleor/components/FormField/constants";
import moment from "moment-timezone";
import { useMemo } from "react";
import { useIntl } from "react-intl";

import { getSalesPartnerMapping } from "./utils";

const useNotRefPartner = (
  showDetails: boolean,
  paymentTerm,
  formik,
  isChangeFlow,
  isViewMode
) => {
  const intl = useIntl();
  const orderType = formik?.values?.orderType === "ZP20";
  const isDeliveryType = (status, allowedStatuses) =>
    allowedStatuses.includes(status);
  const deliveryTypeTax = isDeliveryType(formik?.values?.orderStatus, [
    "Partial Delivery",
    "Completed Delivery",
    "Cancelled (93)"
  ]);
  const deliveryTypeReqDate = isDeliveryType(formik?.values?.orderStatus, [
    "Completed Delivery",
    "Cancelled (93)"
  ]);
  const deliveryTypePoDate = isDeliveryType(formik?.values?.orderStatus, [
    "Received Order",
    "Partial Delivery",
    "Completed Delivery",
    "Cancelled (93)"
  ]);

  const paymentTermList = getSalesPartnerMapping(paymentTerm);

  const taxClassificationList = [
    { value: "0", label: "0 : Liable for taxes 0%" },
    { value: "1", label: "1 : Liable for Tax" }
  ];

  const formPartnerData = useMemo(
    () => [
      {
        title: intl.formatMessage({ defaultMessage: "Payment Term" }),
        name: "paymentTerm",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "Payment Term"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: paymentTermList,
        md: 6,
        isfieldVisibility: !showDetails,
        isDisabled: isChangeFlow && !isViewMode && orderType
      },
      {
        title: intl.formatMessage({ defaultMessage: "Tax Classification" }),
        name: "taxClass",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "Tax Classification"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: taxClassificationList,
        md: 6,
        isfieldVisibility: !showDetails,
        isDisabled: isChangeFlow && !isViewMode && deliveryTypeTax
      },
      {
        title: intl.formatMessage({ defaultMessage: "PO Date" }),
        name: "poDate",
        required: false,
        placeholder: intl.formatMessage({
          defaultMessage: "PO Date"
        }),
        type: FIELD_TYPE.DATEPICKER,
        disableFutureDate: false,
        md: 6,
        isfieldVisibility: !showDetails,
        isDisabled: isChangeFlow && !isViewMode && deliveryTypePoDate
      },
      {
        title: intl.formatMessage({ defaultMessage: "Request Date" }),
        name: "requestDate",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "Request Date"
        }),
        type: FIELD_TYPE.DATEPICKER,
        minDate: moment(),
        disableFutureDate: false,
        md: 4,
        isfieldVisibility: !showDetails,
        isDisabled: isChangeFlow && !isViewMode && deliveryTypeReqDate,
        ...(isChangeFlow && {
          warningMessage:
            "การแก้ไข Request Date อาจส่งผลกระทบให้ราคามีการเปลี่ยนแปลง"
        })
      },
      {
        type: "Button",
        name: "applyAll"
      },
      {
        title: intl.formatMessage({ defaultMessage: "PO No." }),
        name: "poNumber",
        required: false,
        placeholder: intl.formatMessage({
          defaultMessage: "ระบุเลขที่ใบสั่งซื้อ"
        }),
        type: FIELD_TYPE.SINGLE_INPUT,
        md: 6,
        isfieldVisibility: !showDetails,
        maxLength: 35
      }
    ],
    [showDetails, paymentTermList, taxClassificationList]
  );

  return {
    formPartnerData
  };
};

export default useNotRefPartner;
